import * as S from './Hero.style'
import mockup from '../../Assets/mockup_1.png'
import { motion } from 'framer-motion';

export const Hero = () => {
  return (
    <S.Wrapper>
      {/* Animação do Texto */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className='xl:w-[50%]'
      >
        <S.Title>
          <span className="text-[var(--azul)]">Transforme desafios logísticos em</span> oportunidades lucrativas
        </S.Title>

        <S.Text>
          Descubra como a BindTrack pode otimizar sua gestão logística, reduzindo custos, aumentando a eficiência e integrando soluções avançadas em tempo real.
        </S.Text>
      </motion.div>

      {/* Animação da Imagem */}
      <motion.div
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 0.3 }}
      >
        <S.Image src={mockup} alt="mockup" />
      </motion.div>
    </S.Wrapper>
  )
}
